import React, { useState, useEffect } from "react";
import {
	Modal,
	Box,
	Typography,
	Card,
	CardContent,
	Button,
	TextField,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
	IconButton,
	Tabs,
	Tab,
	InputAdornment,
} from "@mui/material";
import InfoHoverTooltip from "../Tooltips/InfoHover";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";

import Header from '../partials/header';
import LeftSidebar from '../partials/leftSidebar';
import sitesIcon from '../../assets/images/icon/sites.svg';
import eyeIcon from '../../assets/images/icon/eye.png';
import threeDotsIcon from '../../assets/images/icon/threedots.png';
import licensesIcon from '../../assets/images/icon/licenses.svg';
import customersIcon from '../../assets/images/icon/customers.svg';
import homeIcon from '../../assets/images/icon/home.svg';
import { getMethod } from "../../services/apiService";
import { Image } from "react-bootstrap";
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { epochToFormattedDate, getUserId } from "../../helper/helper";
import { usePartnerIdContext } from "../../context/partnerIdContext";
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from "@mui/material/CircularProgress";

type DataItem = {
	orderId: string;
	siteId: number;
	partnerId: string;
	createdAt: number;
	data: {
		featureKey: string;
		licenseKey: string;
		quantity: number;
		validity: number;
		createdAt: number;
		activationOn: number;
		expiry: number;
		status: number;
		name: string;
	}[];
};

const CustomerLicenseTab = ({ data = [] ,  isLoading = false }: any) => {







	const [open, setOpen] = useState(false);
	const { partnerId, setPartnerId } = usePartnerIdContext();
	const [searchText, setSearchText] = useState<string>("");
	const [filteredCustomers, setFilteredCustomers] = useState<any>([]);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const [activeTab, setActiveTab] = useState(0);


	const [licenseData, setLicenseData] = useState<any>([])



	const combinedData = Array.isArray(data)
		? data.flatMap((item: any) =>
			item.siteOrder?.data?.map((dataItem: any) => ({
				...dataItem,
				totalQuantity: item?.countData?.total, // Add total quantity field
				availableQantity: item?.countData?.available, // Add available field
				assignedQuantity: item?.countData?.assigned
			}))
		) : [];



	const handleTabChange = (event: any, newValue: number) => {
		setActiveTab(newValue);
	}


	return (


		<Box sx={{ backgroundColor: "#03171F", color: "#ffffff", minHeight: "100vh" }}>
			{/* Summary Section */}


			<Grid container mb={5}>
				<Grid size={{ xs: 12, md: 6 }}>
					<TextField
						fullWidth
						placeholder="Search by customer name or address"
						variant="outlined"
						className="searchBox"
						onChange={(e) => setSearchText(e.target.value)}
						sx={{
							backgroundColor: "#1e222b",
							input: { color: "#ffffff" },
							borderRadius: "30px",
							border: "1px solid #5A5F60",
							padding: "0 5px !important",
							height: "41px",
							fontWeight: "normal",
							"& .MuiOutlinedInput-root": {
								"& fieldset": {
									borderColor: "transparent", // Default border color
								},
								"&:hover fieldset": {
									borderColor: "transparent", // Border color on hover
								},
								"&.Mui-focused fieldset": {
									borderColor: "transparent", // Remove border when active
								},
							},
						}}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon style={{ color: "#ffffff", cursor: "pointer" }} />
								</InputAdornment>
							),
						}}
					/>

				</Grid>
			</Grid>

			{/* Table Section */}
			<Table sx={{ backgroundColor: "#03171f", border: '1px solid #313838' }}>
				<TableHead sx={{ border: '1px solid #313838' }}>
					<TableRow>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>No.</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>License Item(SKU)</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>Quantity</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>Issue Date</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>Expiry Date</TableCell>
						<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>License Key</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
						  {isLoading ? (
					<TableRow>
					<TableCell colSpan={6} sx={{ textAlign: 'center', borderColor: '#313838', padding: '32px' }}>
						<CircularProgress size={32} sx={{ color: '#1976d2' }} />
					</TableCell>
					</TableRow>
				) : (
					<>
					{combinedData
						.filter((license: any) =>
							license?.featureName?.toLowerCase().includes(searchText.toLowerCase())
						)
						.map((license: any, index: any) => (
							<TableRow key={license.id} sx={{ padding: '0', margin: '0', }}>
								<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', }}>{index + 1}</TableCell>

								<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', border: "none", padding: '0', margin: '0', }}>{license?.featureName}</TableCell>
								{/* <TableCell sx={{ color: '#B4B7B8', fontSize: '14px', border: "none", padding: '0', margin: '0', }}> {license?.assignedQuantity} / {license?.totalQuantity}</TableCell> */}



								<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', border: "none", padding: '0', margin: '0' }}>
									<InfoHoverTooltip title={"Used / Total"}
										arrowDirection="top">
										<Typography component="span">
											{license?.assignedQuantity} / {license?.totalQuantity}
										</Typography>
									</InfoHoverTooltip>


								</TableCell>


								<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', border: "none", padding: '0', margin: '0', }}>{epochToFormattedDate(license?.createdAt)}</TableCell>
								<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', border: "none", padding: '0', margin: '0', }}>{epochToFormattedDate(license.expiry)}</TableCell>
								<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', border: "none", padding: '0', margin: '0', }}>{license.licenseKey}</TableCell>


							</TableRow>
						))}
					{!combinedData.length && !isLoading &&
						<TableRow>
							<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', textAlign: 'center' }} colSpan={6}>
								No Data
							</TableCell>
						</TableRow>
					}
					  
					</>
				)}
				</TableBody>
			</Table>
		</Box >

	);
};

export default CustomerLicenseTab;
